var _desc, _defs, _rect, _rect2, _circle, _circle2, _path, _path2, _text, _text2, _g, _text3, _text4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValenciaPassport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 760",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Valencia Comedy Passport") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A bright illustrated audience passport for Valencia comedy shows.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#181c25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07090c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow",
    cx: 0.28,
    cy: 0.2,
    r: 0.72
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff4d6",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ffb45f",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7c24",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 760,
    rx: 54,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 760,
    rx: 54,
    fill: "url(#glow)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 960,
    cy: 155,
    r: 54,
    fill: "#ffffff",
    opacity: 0.14
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1040,
    cy: 250,
    r: 92,
    fill: "#ffffff",
    opacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142 158h430c36 0 66 30 66 66v324c0 36-30 66-66 66H142c-36 0-66-30-66-66V224c0-36 30-66 66-66Z",
    fill: "#fff",
    opacity: 0.97
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155 232h350M155 318h320M155 404h250",
    stroke: "#ff7c24",
    strokeWidth: 26,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 152,
    y: 525,
    fontFamily: "Arial, sans-serif",
    fontSize: 54,
    fontWeight: 800,
    fill: "#171b22"
  }, "Valencia")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 152,
    y: 585,
    fontFamily: "Arial, sans-serif",
    fontSize: 36,
    fontWeight: 700,
    fill: "#596372"
  }, "Comedy Passport")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(740 210)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 180,
    width: 250,
    height: 22,
    rx: 11,
    fill: "#fff",
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 173 154 36c8-20 35-20 43 0l57 137",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 26,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 27,
    r: 62,
    fill: "#ff7c24"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 27,
    r: 34,
    fill: "#fff"
  }))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 736,
    y: 560,
    fontFamily: "Arial, sans-serif",
    fontSize: 46,
    fontWeight: 900,
    fill: "#fff"
  }, "Six gigs.")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 736,
    y: 616,
    fontFamily: "Arial, sans-serif",
    fontSize: 46,
    fontWeight: 900,
    fill: "#ffb45f"
  }, "One stamp run.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValenciaPassport);
export default __webpack_public_path__ + "static/media/valencia-passport.25c65d14f60ae4dc98fdd45b3703f1ca.svg";
export { ForwardRef as ReactComponent };